import { Login } from "../../../Pages/Login";
import { NavBar } from "../../NavBar";
import { Main } from "../../../Pages/Main";
import { Ayuda } from "../../../Pages/Ayuda";
import { AgenciasPreimpresos } from "../../../Pages/AgenciasPreimpresos";
import { ComprobantesInstantaneos } from "../../../Pages/ComprobantesInstantaneos";
import { Comprobantes } from "../../../Pages/Comprobantes";
import { CuponesGanadores } from "../../../Pages/CuponesGanadores";
import { CuponesPreimpresos } from "../../../Pages/CuponesPreimpresos";
import { Devoluciones } from "../../../Pages/Devoluciones";
import { EntregasDevolucionesInstantaneos } from "../../../Pages/EntregasDevolucionesInstantaneos";
import { EntregasDevolucionesPreimpresos } from "../../../Pages/EntregasDevolucionesPreimpresos";
import { Instantaneos } from "../../../Pages/Instantaneos";
import { Juegos } from "../../../Pages/Juegos";
import { MatrizControlED } from "../../../Pages/MatrizControlED";
import { OrdenesPedido } from "../../../Pages/OrdenesPedido";
import { PagoCupones } from "../../../Pages/Pagos";
import { PremiosPagadosInstantaneos } from "../../../Pages/ConsultasPremiosPagadosInstantaneos";
import { PremiosPagados } from "../../../Pages/PremiosPagados";
import { Proveedores } from "../../../Pages/Proveedores";
import { ProveedoresInstantaneos } from "../../../Pages/ProveedoresInstantaneos";
import { ProveedoresPreimpresos } from "../../../Pages/ProveedoresPreimpresos";
import { Reportes } from "../../../Pages/Reportes";
import { Sorteos } from "../../../Pages/Sorteos";
import { Stock } from "../../../Pages/Stock";
import { StockInstantaneos } from "../../../Pages/StockInstantaneos";
import { StockPreimpresos } from "../../../Pages/StockPreimpresos";
import PrivateRoute from "../../../../helpers/PrivateRoute";
import { NavBarAdmin } from "../../NavBarAdmin";
import { LogOut } from "../../../../actions/LogOut";
import { Colors } from "../../../Pages/Colors";
import { Logos } from "../../../Pages/Logos";
import { Configure } from "../../../Pages/Configure/index";
import { CreateConfigure } from "../../../Pages/Configure/addConfigure";
import { Preload } from "../../../../helpers/Preload";
import { GamesLogos } from "../../../Pages/JuegosLogos/index";
import { Organizations } from "../../../Pages/Organizations";
import ConcentratorSelected from "../../../Pages/Concentrators/ConcentratorSelected/ConcentratorSelected";
import AgencieSelected from "../../../Pages/Concentrators/AgencieSelected/AgencieSelected.jsx";
import Concentrators from "../../../Pages/Concentrators/Concentrators.jsx";
import { Remitos } from "../../../Pages/Remitos/Remitos.jsx";
import { Impreso } from "../../../Pages/Remitos/Impreso/Impreso";
import { ImpresoOrders } from "../../../Pages/OrdenesPedido/Impreso/Impreso";
import Cupones from "../../../Pages/Cupones";
import Movements from "../../../Pages/Cupones/Movements/Movements";
import OrderDetail from "../../../Pages/OrdenesPedido/Detail";
import PreDistributionTelekino from "../../../Pages/ProcessFiles/PreDistributionTelekino/PreDistributionTelekino";
import VentasTelekino from "../../../Pages/ProcessFiles/VentasTelekino/VentasTelekino";
import PremiosMayores from "../../../Pages/ProcessFiles/PremiosMayores/PremiosMayores";
import CuponesGanadoresTelekino from "../../../Pages/ProcessFiles/CuponesGanadores/CuponesGanadoresTelekino";
import MasivosSalpren from "../../../Pages/ProcessFiles/MasivosSalpren";
import ArchivosSalvta from "../../../Pages/ProcessFiles/ArchivosSalvta";
import UsersRefactor from "../../../Pages/Refactor User";
import { AboutVersion } from "../../../../components/Pages/AboutVersion";
import { ResetPassword } from "../../../Pages/ResetPassword";
import { OrderReview } from "../../../Pages/AgencyOrders/Backoffice/OrderReview";
import { OrderApprovalSuccess } from "../../../Pages/AgencyOrders/Backoffice/OrderApprovalSuccess";

export const routes = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "logout",
    element: <LogOut />,
  },
  {
    path: "/main",
    element: (
      <PrivateRoute>
        <NavBar />
      </PrivateRoute>
    ),
    errorElement: <Login />,
    children: [
      { path: "PreDistributionTelekino", element: <PreDistributionTelekino /> },
      { path: "VentasTelekino", element: <VentasTelekino /> },
      { path: "PremiosMayores", element: <PremiosMayores /> },
      {
        path: "CuponesGanadoresTelekino",
        element: <CuponesGanadoresTelekino />,
      },
      {
        path: "CuponesGanadoresTelekino/see",
        element: <CuponesGanadoresTelekino />,
      },
      { path: "panel", element: <Main /> },
      { path: "agencias-preimpresos", element: <AgenciasPreimpresos /> },
      { path: "ayuda", element: <Ayuda /> },
      {
        path: "comprobantes-instantaneos",
        element: <ComprobantesInstantaneos />,
      },
      { path: "comprobantes", element: <Comprobantes /> },
      { path: "matriz-control-ed", element: <MatrizControlED /> },
      { path: "cupones-ganadores", element: <CuponesGanadores /> },
      { path: "cupones-preimpresos", element: <CuponesPreimpresos /> },
      { path: "devoluciones", element: <Devoluciones /> },
      {
        path: "entregas-devoluciones-instantaneos",
        element: <EntregasDevolucionesInstantaneos />,
      },
      {
        path: "entregas-devoluciones-preimpresos",
        element: <EntregasDevolucionesPreimpresos />,
      },
      { path: "instantaneos", element: <Instantaneos /> },
      { path: "juegos", element: <Juegos /> },
      { path: "juegos/create", element: <Juegos /> },
      { path: "ordenes-pedido", element: <OrdenesPedido /> },
      { path: "ordenes-pedido/create", element: <OrdenesPedido /> },
      { path: "ordenes-pedido/details/:id", element: <OrderDetail /> },
      { path: "ordenes-pedido/impreso/:id", element: <ImpresoOrders /> },
      { path: "pagos", element: <PagoCupones /> },
      {
        path: "premios-pagados-instantaneos",
        element: <PremiosPagadosInstantaneos />,
      },
      { path: "premios-pagados-preimpresos", element: <PremiosPagados /> },
      { path: "premiados-salprem", element: <MasivosSalpren /> },
      { path: "ventas-salvta", element: <ArchivosSalvta /> },
      { path: "proveedores", element: <Proveedores /> },
      { path: "proveedores/create", element: <Proveedores /> },
      {
        path: "proveedores-instantaneos",
        element: <ProveedoresInstantaneos />,
      },
      { path: "proveedores-preimpresos", element: <ProveedoresPreimpresos /> },
      { path: "remitos", element: <Remitos /> },
      { path: "remitos/create", element: <Remitos /> },
      { path: "remitos/impreso/:id", element: <Impreso /> },
      { path: "remitos/detail", element: <Remitos /> },
      { path: "reportes", element: <Reportes /> },
      { path: "productos", element: <Sorteos /> },
      { path: "productos/create", element: <Sorteos /> },
      { path: "stock-instantaneos", element: <StockInstantaneos /> },
      { path: "stock-preimpresos", element: <StockPreimpresos /> },
      { path: "stock", element: <Stock /> },
      { path: "stock-de-cupones", element: <Cupones /> },
      {
        path: "stock-de-cupones/:game/:gameId/:raffleId/:num",
        element: <Movements />,
      },
      {
        path: "stock-de-cupones/revisar/:id",
        element: <OrderReview />,
      },
      {
        path: "stock-de-cupones/pedidos-agencias/aprobado/:id",
        element: <OrderApprovalSuccess />,
      },
      { path: "users", element: <UsersRefactor /> },
      { path: "colors", element: <Colors /> },
      { path: "logos", element: <Logos /> },
      { path: "games-and-logos", element: <GamesLogos /> },
      { path: "configure", element: <Configure /> },
      { path: "configure/create", element: <CreateConfigure /> },
      { path: "about", element: <AboutVersion /> },
    ],
  },
  {
    path: "/check-user",
    element: (
      <PrivateRoute>
        <Preload />
      </PrivateRoute>
    ),
  },
  {
    path: "/organizations",
    element: (
      <PrivateRoute>
        <Organizations />
      </PrivateRoute>
    ),
  },
  {
    path: "/admin",
    element: (
      <PrivateRoute>
        <NavBarAdmin />
      </PrivateRoute>
    ),
    children: [
      { path: "users", element: <UsersRefactor /> },
      { path: "sales_points", element: <Concentrators /> },
      {
        path: "sales_points/:name/:numAndSub/:id",
        element: <ConcentratorSelected />,
      },
      { path: "sale_point/:name/:numAndSub/:id", element: <AgencieSelected /> },
      { path: "colors", element: <Colors /> },
      { path: "logos", element: <Logos /> },
      { path: "games-and-logos", element: <Juegos /> },
      { path: "games-and-logos/create", element: <Juegos /> },
      { path: "juegos/create", element: <Juegos /> },
      { path: "configure", element: <Configure /> },
      { path: "configure/create", element: <CreateConfigure /> },
    ],
  },
];
